var map = {
	"./aparthotelclub/ic_email_colored.png": 48868,
	"./beachful/ic_email_colored.png": 64020,
	"./castlepedia/ic_email_colored.png": 67741,
	"./cocktayl/ic_email_colored.png": 33262,
	"./ic_email_colored.png": 8119,
	"./luxresortclub/ic_email_colored.png": 84706,
	"./parkful/ic_email_colored.png": 30040,
	"./prefabworld/ic_email_colored.png": 72180,
	"./rooftopclub/ic_email_colored.png": 69943,
	"./spaclub/ic_email_colored.png": 2815,
	"./worldcasino/ic_email_colored.png": 15379,
	"./zoopedia/ic_email_colored.png": 8866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40938;